
import { FC, useContext, useEffect } from 'react';

import { LoadingActionContext } from '../../contexts/layouts/LoadingActionContext';

interface IIsLoadingProps {
    name: string;
    loading: boolean;
    validating: boolean;
}

const IsLoading: FC<IIsLoadingProps> = ({
    name,
    loading,
    validating
}) => {

    const { setLoading, setLoaded, setValidating, setValid } = useContext(LoadingActionContext);

    useEffect(() => {
        if (loading) {
            setLoading(name);
        } else {
            setTimeout(() => setLoaded(name), 0);
        }

    }, [name, loading, setLoading, setLoaded])

    useEffect(() => {
        if (validating) {
            setValidating(name);
        } else {
            setTimeout(() => setValid(name), 0);
        }
        
    }, [name, validating, setValidating, setValid])

    useEffect(() => {
        return () => {
            setLoaded(name),
            setValid(name)
        }
        
    }, [name, setLoaded, setValid])

    return null;
}

export default IsLoading